import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getEnvVariables } from '../../helpers/getEnvVariables';
const { REACT_APP_URL } = getEnvVariables();
export const eventsApi = createApi({
    reducerPath: 'events',
    baseQuery: fetchBaseQuery({ baseUrl: REACT_APP_URL }),
    endpoints: (builder) => ({
        getEvents: builder.query({
            query: () => 'event-global',
            keepUnusedDataFor: 600,
        }),
        getEvent: builder.query({
            query: (id) => ({
                url: `event/${id}`,
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Content-Length': '2000000',

                }),
                timeout: 10000,
            }),

        }),
        getPhasesByEvent: builder.mutation({
            query: (data) => ({
                url: "locality/phase-current",
                method: 'POST',
                body: data,
            }),
        }),
        getZonesByLocality: builder.query({
            query: (localityId) => `locality-zones/${localityId}`,
        }),
        deleteSeatsByLocality: builder.mutation({
            query: (localityId) => ({
                url: `locality-zone/cancel-locality-topics/${localityId}`,
                method: 'DELETE',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': JSON.parse(localStorage.getItem('user')!)?.token,
                }),
            }),
        }),
        getOrderEventByCustomer: builder.query({
            query: (data) => ({
                url: `customer/ticket-orders/${data._id}/${data.status}`,
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': JSON.parse(localStorage.getItem('user')!)?.token,
                }),
            }),
        }),
        getSubscriptionsByCustomer: builder.query({
            query: (data) => ({
                url: `subscriber-getList/byCustomer/${data._id}`,
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': JSON.parse(localStorage.getItem('user')!)?.token,
                }),
            }),
        }),
    }),
});

export const { useGetEventsQuery, useGetPhasesByEventMutation, useGetZonesByLocalityQuery, useDeleteSeatsByLocalityMutation, useGetEventQuery, useGetOrderEventByCustomerQuery, useLazyGetSubscriptionsByCustomerQuery } = eventsApi;